<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo() {
    const meta = []
    
    if (this.$route.meta.description) {
      meta.push({
        vmid: 'description',
        name: 'description',
        content: this.$route.meta.description
      })
    }
    
    if (this.$route.meta.keywords) {
      meta.push({
        vmid: 'keywords',
        name: 'keywords',
        content: this.$route.meta.keywords
      })
    }
    
    return {
      title: this.$route.meta.title,
      meta: meta
    }
  },
  watch: {
    '$route' () {
      this.$meta().refresh()
    }
  }
}
</script>

<style lang="scss">
</style>
